import { type ServiceMethod } from '@/application/interfaces/service';

export type Body = {
  token: string;
  cartId: string;
  branded?: string;
  brand?: string;
};

export type Response = {
  data: {
    hashCard: string;
  };
};

const verifyCreditCardToken: ServiceMethod<Response, Body> =
  (httpClient) => async (data, options) => {
    const { cartId, token, brand, branded } = data;

    const { body: response } = await httpClient.post<Response, Body>(
      '/api/v3/credit-card/verify-token',
      {
        ...options,
        body: { cartId, token, brand, branded },
      }
    );

    return response;
  };

export default verifyCreditCardToken;
